<template>
  <div>
    <dashboard-navbar :routes="routes"></dashboard-navbar>
    <div class="content" @click="$sidebar.displaySidebar(false)">
      <div class="container-fluid mt-2">
        <card body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h2 class="mb-0 text-uppercase">List Student's Profile</h2>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between mb-3">
              <div class="wrapper-select">
                <span>Show</span>
                <div class="select-row">
                  <el-select
                    class="select-primary pagination-select"
                    size="mini"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
                <span>Row</span>
              </div>
              <div class="form-search">
                <base-input v-model="searchQuery" placeholder="Search Records" size="mini"></base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"></el-table-column>
              <el-table-column min-width="270px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button @click.native="handleDetail($index, row)" type="detail-vr" size="sm">
                    <span>Detail</span>
                  </base-button>
                  <base-button @click.native="handleCourse($index, row)" type="edit-vr" size="sm">
                    <span>Course</span>
                  </base-button>
                  <base-button @click.native="handleUsage($index, row)" type="success-vr" size="sm">
                    <span>Usage</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                <span
                  v-if="selectedRows.length"
                >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '@/components';
import DashboardNavbar from '@/Layout/DashboardNavbar.vue';
import { getAllMember } from '@/services/student'
import listStudentsMixin from './Mixins/listStudentsMixin'
import { mapActions, } from 'vuex'
import Fuse from "fuse.js";
export default {
  mixins: [listStudentsMixin],
  name: "ListStudents",
  components: {
    BasePagination,
    DashboardNavbar,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      propsToSearch: ['name', 'npaidi', 'email', 'institute', 'specialist.name'],
      tableColumns: [
        {
          prop: 'name',
          label: 'FullName',
          minWidth: 180,
          sortable: true
        },
        {
          prop: 'npaidi',
          label: 'NPA IDI',
          minWidth: 150,
          sortable: true
        },
        {
          prop: 'email',
          label: 'Email',
          minWidth: 280,
          sortable: true
        },
        {
          prop: 'institute',
          label: 'Institute',
          minWidth: 210,
          sortable: true
        },
        {
          prop: 'specialist.name',
          label: 'Specialist',
          minWidth: 180,
          sortable: true
        },
      ],
      tableData: [],
      selectedRows: [],
      routes: [
        {
          name: "ListStudents",
          alias: "List Students"
        }
      ]
    };
  },
  methods: {
    ...mapActions('student', ['setSelectedStudent']),
    handleDetail(index, row) {
      this.$router.push({ name: 'ListStudentsId', params: { id: row.id } })
    },
    handleCourse(index, row) {
      this.setSelectedStudent(row)
      this.$router.push({ name: 'ListStudentsCourse', params: { id: row.id } })
    },
    handleUsage(index, row) {
      this.$router.push({ name: 'ListStudentsUsage', params: { id: row.id } })
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    async getAllStudents() {
      try {
        const { data } = await getAllMember()
        this.tableData = data
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      } catch (error) {
        if (error.code === 401) {
          this.$cookies.remove('CERT');
          this.$store.dispatch('auth/removeAuth');
          this.$router.replace({ name: "Login" })
          this.$notify({
            type: "danger",
            verticalAlign: "top",
            horizontalAlign: "center",
            closeOnClick: true,
            message: error.msg
          });
        } else {
          this.$notify({
            type: "danger",
            verticalAlign: "top",
            horizontalAlign: "center",
            closeOnClick: true,
            message: error
          });
        }
      }
    }
  },
  mounted() {
    this.getAllStudents()
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/argon.scss";
.pagination-select {
  margin: 0 5px;
}
.wrapper-select {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .select-row {
    width: 75px;
    margin-right: 10px;
  }
}
</style>
